import { ITableCellAdapter } from "./table-cell-adapter/table-cell-adapter.interface"

export class TableDatasourceAdapter {
    constructor (
        public display: ITableCellAdapter[],
        public data: any) {
    }
}